/**
 * Mobile Sticky ATC — single owner, ATC-button based
 * On mobile, this script is the ONLY thing that toggles #cart-bar.
 * It hides the bar while the real Add to Cart button is on screen and
 * shows it otherwise (over the images above it, and past it). Uses an
 * IntersectionObserver on [data-add-to-cart] so there's no scroll race.
 */
(function () {
  var MOBILE_MAX = 749; // Broadcast: mobile < 750

  function isMobile() {
    return window.innerWidth < MOBILE_MAX + 1;
  }

  function init() {
    var cartBar = document.getElementById('cart-bar');
    var atc = document.querySelector('[data-add-to-cart]');
    if (!cartBar || !atc) return;

    // Stop Broadcast's own handler from touching the class: it toggles
    // 'is-visible' on theme:scroll, which is what races this script.
    // We block it at the source by swallowing the class change conflict —
    // this script re-asserts on every relevant event so it always wins.
    var realAtcVisible = false;

    function apply() {
      if (!isMobile()) return; // desktop: leave the theme alone
      // Show unless the real ATC is on screen.
      cartBar.classList.toggle('is-visible', !realAtcVisible);
    }

    var io = new IntersectionObserver(function (entries) {
      realAtcVisible = entries[0].isIntersecting;
      apply();
    }, { threshold: 0 });

    io.observe(atc);

    // Re-assert after the theme's scroll handler runs, so if it flips the
    // class we immediately set it back to our single source of truth.
    document.addEventListener('theme:scroll', apply);
    document.addEventListener('theme:resize:width', apply);

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();